import { useContext } from "react";
import {
  SelectedAppContext,
  type SelectedAppContextValue,
} from "@/lib/selectedAppContextValue";

/**
 * Selected-app + session context consumer hook.
 *
 * Source: BRIEF_ia-redesign-frontend-implementation § 5.3.
 *
 * Lives in its own module so the SelectedAppProvider component can satisfy
 * the React Fast Refresh "components-only" export rule
 * (react-refresh/only-export-components).
 */

export function useSelectedAppContext(): SelectedAppContextValue {
  const ctx = useContext(SelectedAppContext);
  if (!ctx) {
    throw new Error(
      "useSelectedAppContext must be used inside <SelectedAppProvider>",
    );
  }
  return ctx;
}
